export const CREATE_SA_URL_GROUP_NAME = "create_search_analytics_url_group";
export const CREATE_SA_URL_GROUP_DESC = `Creates a URL Group under a Search Analytics project.

Use when the user wants to add a URL grouping for Search Analytics. If only projectId is provided, the tool resolves the corresponding Search Analytics ID automatically.

Input (one of "projectId" or "searchAnalyticsId" is required):
- "projectId": Search Analytics Project ID. The tool resolves the Search Analytics ID.
- "searchAnalyticsId": Search Analytics ID directly.
- "name" (required): URL Group name.
- "op" (required): Logical operator (AND|OR).
- "patterns" (required): Array of { type, pattern }.
  - type must be one of: CONTAINS, NOT_CONTAINS, STARTS_WITH, ENDS_WITH, EQUALS, REGEX, NOT_REGEX, SUB_DOMAIN, DEPTH1, DEPTH2, DEPTH3, INCLUDES, NOT_INCLUDES.
- Optional: description, prepend (boolean, defaults false).

Notes:
- Be forgiving: infer missing pieces and tidy inputs before calling. Examples:
  - If the user provides a pasted CSV/TSV/line list, trim blanks, drop duplicates, ignore empty lines, and map each row to { type, pattern }. Default type = CONTAINS unless the row begins with a known type followed by a comma/tab/space (e.g., "REGEX,/news.*").
  - If the intent is unclear, prefer AND for safer grouping. Keep the user’s explicit op if given.
  - Normalize patterns: strip surrounding quotes/spaces, keep scheme-less paths (e.g., "example.com/path" -> "/path" only if the user clearly wants path match), but do not alter the core string beyond safe trimming.
  - If a row looks like a full URL, use STARTS_WITH unless the user requested a different type.
  - When the user intends “many rules in one group”, batch them into a single patterns array.
- Write operation (mutation). Returns created URL Group fields plus resolved projectId and searchAnalyticsId.`;
